<template>
  <v-container>
    <v-dialog
        overlay-color="grey"
        overlay-opacity="0.5"
        :value="dialog"
        @input="dialog = $event"
        max-width="1500"
        scrollable
    >
      <v-sheet height="100%">
        <card-account
            :selected-account-id="selectedAccountId"
            :is-show-personal-info="isManager"
            @saveUser="saveUser"
        >
          <v-btn color="blue darken-4" dark small @click="$emit('hide')">Close(닫기)</v-btn>
        </card-account>

      </v-sheet>
    </v-dialog>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import CardAccount from "@/components/Card/CardAccount";

export default {
  name: 'DialogAccount',
  components: {CardAccount  },
  props: {
    value: {type: Boolean, required: true},
    selectedAccount: {type: Object},
    selectedAccountId: {type: Number},
  },
  data(){
    return {
      idExist: false,
      idNotExist: false,
      listLoading: true,
    }
  },
  destroyed() {},
  computed: {
    ...mapGetters(['app','user', 'isStudent', 'isTeacher', 'isManager']),
    dialog: {
      get() {return this.value},
      set(value) {this.$emit('input', value)},
    },
  },
  created() {
  },
  beforeMount() { },
  mounted() {},
  methods: {
    saveUser(account){
      this.$emit('saveUser', account)
    }
  },

}
</script>
